var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg859",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "130px",
    height: "60px",
    viewBox: "0 0 130 60",
    style: {
      enableBackground: "new 0 0 130 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    {`.st0{fill:#FFFFFF;}`}\n    {`.st1{fill:#32BCAD;}`}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "path2356"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,50.8c-0.4,0-0.8-0.4-0.8-0.8V23.6c0-5.3,4.3-9.6,9.6-9.6l7.8,0c5.3,0,9.6,4.3,9.6,9.6v5.6 c0,5.3-4.3,9.6-9.6,9.6H59c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h11c4.4,0,8-3.6,8-8v-5.6c0-4.4-3.6-8-8-8l-7.8,0 c-4.4,0-8,3.6-8,8V50C54.3,50.4,53.9,50.8,53.5,50.8z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2360"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,38.9c-0.4,0-0.8-0.4-0.8-0.8V18.4c0-1.5-1.3-2.8-2.8-2.8h-3.4c-0.4,0-0.8-0.4-0.8-0.8 c0-0.4,0.4-0.8,0.8-0.8h3.4c2.4,0,4.4,2,4.4,4.4v19.7C88.9,38.6,88.5,38.9,88,38.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2364"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.3,11.7l-1.5-1.5c-0.4-0.4-0.4-1,0-1.4l1.5-1.5c0.4-0.4,1-0.4,1.4,0l1.5,1.5c0.4,0.4,0.4,1,0,1.4l-1.5,1.5 C88.3,12.1,87.7,12.1,87.3,11.7",
    fill: "#32B8AB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2368"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.2,26.1c-0.9,0-1.8-0.4-2.4-1l-7.9-7.9c-1.1-1.1-2.5-1.7-4-1.7h-3.4c-0.4,0-0.8-0.4-0.8-0.8 c0-0.4,0.4-0.8,0.8-0.8h3.4c1.9,0,3.8,0.8,5.2,2.1l7.9,7.9c0.3,0.3,0.8,0.5,1.3,0.5c0.5,0,0.9-0.2,1.3-0.5l7.8-7.8 c1.4-1.4,3.3-2.1,5.2-2.1h2.7c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8h-2.7c-1.5,0-3,0.6-4,1.7l-7.8,7.8 C114,25.7,113.1,26.1,112.2,26.1z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2372"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,38.8h-3.4c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h3.4c1.5,0,2.9-0.6,4-1.7l7.8-7.8 c1.3-1.3,3.5-1.3,4.8,0l7.8,7.8c1.1,1.1,2.5,1.7,4,1.7h2.7c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8h-2.7c-1.9,0-3.8-0.8-5.2-2.1 l-7.8-7.8c-0.7-0.7-1.8-0.7-2.5,0l-7.9,7.9C101.7,38,99.8,38.8,97.9,38.8z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2376"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.5,43c-1.7,0-3.3-0.7-4.5-1.9l-6.4-6.4c-0.4-0.5-1.2-0.4-1.7,0l-6.5,6.5C13.2,42.3,11.7,43,10,43H8.7 l8.2,8.2c2.5,2.5,6.7,2.5,9.2,0l8.2-8.2H33.5z",
    fill: "#32B8AB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2380"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,20.2c1.7,0,3.3,0.7,4.5,1.9l6.5,6.5c0.5,0.5,1.2,0.5,1.7,0l6.4-6.4c1.2-1.2,2.8-1.9,4.5-1.9h0.8L26.1,12 c-2.5-2.5-6.7-2.5-9.2,0l-8.2,8.2H10z",
    fill: "#32B8AB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2384"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,27l-5-5c-0.1,0-0.2,0.1-0.3,0.1h-2.3c-1.2,0-2.3,0.5-3.1,1.3l-6.4,6.4c-0.6,0.6-1.4,0.9-2.2,0.9 c-0.8,0-1.6-0.3-2.2-0.9l-6.5-6.5c-0.8-0.8-2-1.3-3.1-1.3H7.2c-0.1,0-0.2,0-0.3-0.1l-5,5c-2.5,2.5-2.5,6.7,0,9.2l5,5 c0.1,0,0.2-0.1,0.3-0.1H10c1.2,0,2.3-0.5,3.1-1.3l6.5-6.5c1.2-1.2,3.2-1.2,4.4,0l6.4,6.4c0.8,0.8,2,1.3,3.1,1.3h2.3 c0.1,0,0.3,0,0.3,0.1l4.9-4.9C43.6,33.6,43.6,29.5,41,27",
    fill: "#32B8AB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2388"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,47.7c-0.4,0-0.8,0.1-1.2,0.2v1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.8,0,1.2-0.3,1.2-1 C61.1,48,60.8,47.7,60.2,47.7 M58.7,50.7v-3.2h0.2l0,0.1c0.4-0.1,0.9-0.2,1.3-0.2c0.3,0,0.6,0,0.8,0.2c0.3,0.2,0.4,0.6,0.4,1 c0,0.4-0.1,0.8-0.5,1c-0.3,0.2-0.6,0.2-0.9,0.2c-0.3,0-0.6-0.1-1-0.2v0.9L58.7,50.7L58.7,50.7z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2392"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,47.7c-0.8,0-1.2,0.3-1.2,1c0,0.7,0.3,1,1.2,1c0.8,0,1.2-0.3,1.2-1C64.6,48.1,64.3,47.7,63.4,47.7  M64.5,49.7c-0.3,0.2-0.6,0.3-1,0.3c-0.4,0-0.8-0.1-1-0.3c-0.3-0.2-0.4-0.5-0.4-1c0-0.4,0.1-0.8,0.4-1c0.3-0.2,0.6-0.3,1-0.3 c0.4,0,0.8,0.1,1,0.3c0.3,0.2,0.4,0.6,0.4,1C64.9,49.1,64.8,49.5,64.5,49.7",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2396"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.3,49.9L67.4,48h0l-0.9,1.9h-0.3l-1-2.3h0.3l0.8,1.9h0l0.9-1.9h0.3l0.9,1.9h0l0.8-1.9h0.3l-1,2.3H68.3z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2400"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.3,47.7c-0.8,0-1,0.3-1,0.8h2.1C72.3,48,72,47.7,71.3,47.7 M71.2,49.9c-0.4,0-0.7-0.1-1-0.3 c-0.3-0.2-0.4-0.6-0.4-1c0-0.4,0.1-0.8,0.4-1c0.3-0.2,0.6-0.2,0.9-0.2c0.3,0,0.7,0,0.9,0.2c0.3,0.2,0.4,0.6,0.4,1.1h-2.4 c0,0.5,0.2,0.9,1.1,0.9c0.4,0,0.8-0.1,1.2-0.1v0.3C72.1,49.9,71.6,49.9,71.2,49.9",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2404"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.4,49.9v-2.3h0.2l0,0.1c0.5-0.1,0.7-0.2,1.2-0.2h0v0.3h-0.1c-0.4,0-0.6,0.1-1.1,0.2v1.9L73.4,49.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2408"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.4,47.7c-0.8,0-1,0.3-1,0.8h2.1C77.4,48,77.1,47.7,76.4,47.7 M76.4,49.9c-0.4,0-0.7-0.1-1-0.3 c-0.3-0.2-0.4-0.6-0.4-1c0-0.4,0.1-0.8,0.4-1c0.3-0.2,0.6-0.2,0.9-0.2c0.3,0,0.7,0,0.9,0.2c0.3,0.2,0.4,0.6,0.4,1.1h-2.4 c0,0.5,0.2,0.9,1.1,0.9c0.4,0,0.8-0.1,1.2-0.1v0.3C77.2,49.9,76.8,49.9,76.4,49.9",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2412"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.7,47.9c-0.3-0.1-0.6-0.2-0.9-0.2c-0.8,0-1.2,0.3-1.2,1c0,0.7,0.3,1,0.9,1c0.4,0,0.8-0.1,1.2-0.2 L80.7,47.9L80.7,47.9z M80.7,49.9l0-0.1c-0.4,0.1-0.9,0.2-1.3,0.2c-0.3,0-0.6,0-0.8-0.2c-0.3-0.2-0.4-0.6-0.4-1 c0-0.4,0.1-0.8,0.5-1c0.3-0.2,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,1,0.2v-1.1H81v3.3L80.7,49.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,47.7c-0.4,0-0.8,0.1-1.2,0.2v1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.8,0,1.2-0.3,1.2-1C85.9,48,85.6,47.7,85,47.7  M85.7,49.7c-0.3,0.2-0.6,0.2-0.9,0.2c-0.3,0-0.7-0.1-1-0.2l0,0.1h-0.2v-3.3h0.3v1.1c0.4-0.1,0.9-0.2,1.2-0.2c0.3,0,0.6,0,0.8,0.2 c0.3,0.2,0.4,0.6,0.4,1C86.2,49.1,86,49.5,85.7,49.7",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2420"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.5,50.8v-0.3c0.1,0,0.3,0,0.3,0c0.3,0,0.5-0.1,0.7-0.5l0.1-0.2l-1.2-2.3h0.3l1,2h0l1-2h0.3l-1.3,2.6 c-0.2,0.5-0.5,0.6-1,0.6C86.8,50.8,86.7,50.8,86.5,50.8",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2424"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.9,48.6H92v0.8h0.9c0.6,0,0.9-0.1,0.9-0.4C93.8,48.6,93.4,48.6,92.9,48.6 M92.7,47.2H92v0.8h0.8 c0.6,0,0.8-0.1,0.8-0.4C93.6,47.3,93.3,47.2,92.7,47.2 M94.2,49.7c-0.3,0.2-0.7,0.2-1.5,0.2h-1.4v-3.2h1.4c0.6,0,1,0,1.4,0.2 c0.2,0.1,0.3,0.3,0.3,0.6c0,0.3-0.1,0.6-0.5,0.7v0c0.4,0.1,0.7,0.3,0.7,0.8C94.5,49.3,94.4,49.5,94.2,49.7",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2428"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.2,48.9c-0.3,0-0.5,0-0.8,0c-0.5,0-0.6,0.1-0.6,0.3c0,0.2,0.1,0.3,0.5,0.3c0.3,0,0.7-0.1,1-0.1V48.9z  M97.4,49.9l0-0.1C97,49.8,96.5,50,96.1,50c-0.3,0-0.5,0-0.7-0.2c-0.2-0.1-0.3-0.3-0.3-0.6c0-0.3,0.1-0.5,0.4-0.6 c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.8,0v-0.1c0-0.4-0.2-0.5-0.9-0.5c-0.3,0-0.6,0-0.9,0v-0.5c0.3,0,0.7,0,1,0 c0.4,0,0.8,0,1.1,0.2c0.3,0.2,0.3,0.4,0.3,0.8v1.4L97.4,49.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2432"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.9,49.9v-1.3c0-0.4-0.2-0.6-0.6-0.6c-0.3,0-0.6,0.1-0.9,0.2v1.7h-0.7v-2.3h0.5l0,0.2 c0.4-0.1,0.9-0.2,1.3-0.2c0.3,0,0.6,0,0.8,0.2c0.2,0.2,0.3,0.4,0.3,0.7v1.4L100.9,49.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2436"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.4,49.9c-0.3,0-0.6,0-0.9-0.3c-0.3-0.2-0.4-0.6-0.4-1c0-0.4,0.1-0.8,0.5-1c0.3-0.2,0.7-0.2,1-0.2 c0.3,0,0.5,0,0.8,0V48c-0.2,0-0.5,0-0.8,0c-0.6,0-0.9,0.2-0.9,0.7c0,0.5,0.2,0.7,0.7,0.7c0.3,0,0.6-0.1,1-0.1v0.5 C104.2,49.9,103.8,49.9,103.4,49.9",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2440"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,48c-0.6,0-0.9,0.2-0.9,0.7c0,0.5,0.3,0.8,0.9,0.8c0.6,0,0.9-0.2,0.9-0.7S107.1,48,106.5,48  M107.6,49.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.5,0-0.8-0.1-1.1-0.3c-0.3-0.2-0.4-0.6-0.4-1s0.1-0.8,0.4-1c0.3-0.2,0.7-0.3,1.1-0.3 c0.5,0,0.8,0.1,1.1,0.3c0.3,0.2,0.4,0.6,0.4,1S107.9,49.5,107.6,49.7",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2444"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.8,49.9c-0.4,0-0.8-0.1-1.1-0.3c-0.4-0.3-0.5-0.8-0.5-1.3c0-0.5,0.2-1,0.6-1.4c0.4-0.3,0.8-0.3,1.3-0.3 c0.3,0,0.7,0,1.1,0.1v0.6c-0.3,0-0.8-0.1-1.1-0.1c-0.9,0-1.3,0.3-1.3,1.1c0,0.8,0.3,1.1,1,1.1c0.4,0,0.9-0.1,1.4-0.2v0.6 C112.8,49.8,112.3,49.9,111.8,49.9",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2448"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.2,47.9c-0.5,0-0.8,0.2-0.8,0.5h1.6C116,48.1,115.8,47.9,115.2,47.9 M115.1,49.9c-0.4,0-0.7,0-1-0.3 c-0.3-0.2-0.4-0.6-0.4-1c0-0.3,0.1-0.8,0.4-1c0.3-0.2,0.7-0.3,1-0.3c0.3,0,0.7,0,1,0.2c0.4,0.3,0.4,0.7,0.4,1.2h-2.2 c0,0.3,0.2,0.6,0.8,0.6c0.4,0,0.8-0.1,1.2-0.1v0.5C116.1,49.9,115.6,49.9,115.1,49.9",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2452"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.5,49.9v-1.3c0-0.4-0.2-0.6-0.6-0.6c-0.3,0-0.6,0.1-0.9,0.2v1.7h-0.7v-2.3h0.5l0,0.2 c0.4-0.1,0.9-0.2,1.3-0.2c0.3,0,0.6,0,0.8,0.2c0.2,0.2,0.3,0.4,0.3,0.7v1.4L119.5,49.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2456"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,49.9c-0.3,0-0.6-0.1-0.8-0.3c-0.1-0.2-0.2-0.4-0.2-0.7V48h-0.5v-0.5h0.5l0.1-0.7h0.6v0.7h0.9V48h-0.9 v0.8c0,0.2,0,0.3,0.1,0.4c0.1,0.2,0.2,0.2,0.4,0.2c0.2,0,0.3,0,0.5,0v0.5C122.5,49.9,122.3,49.9,122,49.9",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2460"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.3,49.9v-2.3h0.5l0,0.2c0.4-0.1,0.8-0.2,1.2-0.2c0,0,0,0,0.1,0v0.6c-0.1,0-0.2,0-0.2,0 c-0.3,0-0.6,0-0.9,0.1v1.7L123.3,49.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2464"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.5,48.9c-0.3,0-0.5,0-0.8,0c-0.5,0-0.6,0.1-0.6,0.3c0,0.2,0.1,0.3,0.5,0.3c0.3,0,0.7-0.1,1-0.1 L127.5,48.9z M127.6,49.9l0-0.1c-0.4,0.1-0.9,0.2-1.3,0.2c-0.3,0-0.5,0-0.7-0.2c-0.2-0.1-0.3-0.3-0.3-0.6c0-0.3,0.1-0.5,0.4-0.6 c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0,0.6,0,0.8,0v-0.1c0-0.4-0.2-0.5-0.9-0.5c-0.3,0-0.6,0-0.9,0v-0.5c0.3,0,0.7,0,1,0 c0.4,0,0.8,0,1.1,0.2c0.3,0.2,0.3,0.4,0.3,0.8v1.4L127.6,49.9z",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path2466"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129,46.6h0.7v3.3H129V46.6z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.f2b4966a5dd303693b9d84f63435aeb6.svg";
export { ForwardRef as ReactComponent };